export const LANGUAGES = [
    {value: 'ru', rus: 'Русский', kaz: 'Орысша', eng: 'Russian'},
    {value: 'kz', rus: 'Казахский', kaz: 'Қазақша', eng: 'Kazakh'},
    {value: 'en', rus: 'Английский', kaz: 'Ағылшынша', eng: 'English'},
];
